import { useCallback, useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { cn } from "@/lib/utils";
import { toast } from "sonner";
import { P, diaSemana } from "./util";

export function EscalaMes({ comp, podeEditar }) {
  const [g, setG] = useState(null);
  const [cel, setCel] = useState(null);
  const load = useCallback(() => P(`/escala/${comp}`).then(setG).catch((e) => toast.error(errMsg(e))), [comp]);
  useEffect(() => { setG(null); load(); }, [load]);
  const salvar = async (body) => {
    try {
      await api.put(`/ponto/escala/${cel.colab.id}/${cel.dia.data}`, body);
      setCel(null);
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };
  if (!g) return <p className="text-sm text-muted-foreground"><Loader2 className="mr-2 inline h-4 w-4 animate-spin" />Carregando escala…</p>;
  return (
    <div className="space-y-3">
      <p className="text-sm text-muted-foreground">Cada célula mostra o horário do dia ({podeEditar ? "clique para trocar" : "somente consulta"}). F = folga · fundo azul = troca feita no dia · vermelho = feriado.</p>
      <div className="overflow-x-auto rounded-xl border" data-testid="ponto-escala-grid">
        <table className="text-xs">
          <thead className="bg-muted/50">
            <tr>
              <th className="sticky left-0 z-10 bg-muted px-2 py-2 text-left">Colaborador</th>
              {g.dias.map((d) => (
                <th key={d} className={cn("px-1 py-1 text-center font-normal", g.feriados[d] && "text-red-500")} title={g.feriados[d] || ""}>
                  <span className="block font-semibold">{d.slice(8)}</span>{diaSemana(d)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {g.linhas.map((l) => (
              <tr key={l.colaborador.id} className="border-t">
                <td className="sticky left-0 z-10 whitespace-nowrap bg-background px-2 py-1 font-medium">{l.colaborador.nome}</td>
                {l.dias.map((d) => (
                  <td key={d.data} className="p-0.5">
                    <button type="button" disabled={!podeEditar || d.fora} onClick={() => setCel({ colab: l.colaborador, dia: d })}
                      className={cn("h-8 w-12 rounded text-[11px]", d.fora ? "bg-muted/30 text-muted-foreground/40" : d.codigo ? "bg-primary/10" : "bg-muted text-muted-foreground",
                        d.troca && "ring-2 ring-blue-500", g.feriados[d.data] && !d.fora && "text-red-500")}>
                      {d.fora ? "·" : d.codigo || "F"}
                    </button>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {!g.linhas.length && <p className="text-sm text-muted-foreground">Cadastre colaboradores, horários e escalas em Cadastros e regras.</p>}
      <Dialog open={!!cel} onOpenChange={(o) => !o && setCel(null)}>
        <DialogContent className="max-w-sm">
          <DialogHeader>
            <DialogTitle>{cel?.colab.nome}</DialogTitle>
            <DialogDescription>{cel && new Date(`${cel.dia.data}T12:00:00`).toLocaleDateString("pt-BR", { weekday: "long", day: "2-digit", month: "long" })}</DialogDescription>
          </DialogHeader>
          <div className="grid gap-2">
            {g.horarios.map((h) => (
              <Button key={h.id} variant={cel?.dia.horario_id === h.id ? "default" : "outline"} onClick={() => salvar({ horario_id: h.id })}>
                {h.codigo} · {h.pares.map((p) => p.join("–")).join(" / ")}
              </Button>
            ))}
            <Button variant={cel && !cel.dia.horario_id ? "default" : "outline"} onClick={() => salvar({ horario_id: null })}>Folga</Button>
            {cel?.dia.troca && <Button variant="ghost" onClick={() => salvar({ padrao: true })}>Voltar ao padrão da escala</Button>}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
